<script lang="ts">
    import { _ } from 'svelte-i18n';
    import IconAdd from './Icons/IconAdd.svelte';
    import { canWrite, writeDisabledTooltip } from './Permissions/writeAccess';

    export let text: string = $_('Add');
    /** Ten przycisk zawsze dodaje dane, więc domyślnie wymaga can_write. */
    export let requiresWrite: boolean = true;

    $: writeBlocked = requiresWrite && !$canWrite;
</script>

<!-- tooltip siedzi na obudowie, bo warstwa klikalna przy braku uprawnień nie łapie zdarzeń myszy -->
<div class="wrapper" title={writeBlocked ? $_(writeDisabledTooltip) : ''}>
    <div class="container" class:write-blocked={writeBlocked} on:click>
        <div class="text">{text}</div>
        <IconAdd />
    </div>
</div>

<style>
    .wrapper {
        display: inline-flex;
    }
    .container {
        display: flex;
        align-items: center;
        column-gap: 7px;
        cursor: pointer;
        text-align: right;
    }
    .text {
        font-size: 12px;
        opacity: 0.5;
        text-align: right;
    }
    .container.write-blocked {
        pointer-events: none;
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>
